import { render } from "./DemographicsTags.vue?vue&type=template&id=fecdf09a&ts=true"
import script from "./DemographicsTags.ts?vue&type=script&lang=ts&external"
export * from "./DemographicsTags.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__